import { CommonModule } from '@angular/common'
import { Component, effect, inject, input, OnInit, signal } from '@angular/core'
import { VisioComponentsModule } from '@visio-ai/ui-kit'
import { ScheduleRuleCardComponent } from '../../entities/schedule-rule-card/schedule-rule-card.component'
import { ScheduleRule } from '../../models/schedule-rule.model'
import { ScheduleRuleActionsService } from '../../services/schedule-rule-actions.service'
import { ShopsService } from '../../services/shops.service'
import { SupabaseService } from '../../services/supabase.service'
import { UsersService } from '../../services/users.service'

@Component({
  selector: 'app-schedule-rule',
  imports: [CommonModule, ScheduleRuleCardComponent, VisioComponentsModule],
  templateUrl: './schedule-rule.component.html',
  styleUrl: './schedule-rule.component.scss'
})
export class ScheduleRuleComponent implements OnInit {
  private supabase = inject(SupabaseService)
  private shopsService = inject(ShopsService)
  private usersService = inject(UsersService)
  private actions = inject(ScheduleRuleActionsService)

  shopId = input<string>('')
  cameraId = input<string>('')

  scheduleRule = signal<ScheduleRule | null>(null)
  shopName = signal<string>('')
  userName = signal<string>('')
  loading = signal(true)

  constructor() {
    effect(() => {
      if(this.shopId() && this.cameraId()) {
        this.loadRule()
      }
    })
  }

  ngOnInit() {
    this.actions.initSession()
  }

  private loadRule() {
    this.loading.set(true)

    this.shopsService.getShop(this.shopId()).subscribe(shop => {
      if (shop) this.shopName.set(shop.nome)
    })

    this.supabase.getScheduleRuleByShopAndCamera(this.shopId(), this.cameraId()).subscribe(rule => {
      this.scheduleRule.set(rule)
      this.loading.set(false)

      if (rule?.user_in_charge) {
        this.usersService.listUsers().subscribe(users => {
          const user = users.find(u => u._id === rule.user_in_charge)
          if (user) this.userName.set(user.nome)
        })
      }
    })
  }

  onToggleActive(active: boolean) {
    const rule = this.scheduleRule()
    if (!rule) return
    this.supabase.updateScheduleRule(rule.id, { active }).subscribe(updatedRule => {
      if (updatedRule) this.scheduleRule.set(updatedRule)
    })
  }

  onUpdateWeekdays(weekdays: number[]) {
    const rule = this.scheduleRule()
    if (!rule) return
    this.supabase
      .updateScheduleRule(rule.id, this.actions.buildWeekdayUpdate(weekdays))
      .subscribe(updatedRule => {
        if (updatedRule) this.scheduleRule.set(updatedRule)
      })
  }

  onUpdateSchedulingRequirements(requirements: string) {
    this.actions
      .saveSchedulingRequirements(this.shopId(), requirements)
      .subscribe(() => this.loadRule())
  }

  onRequestUpdateFromAdmin() {
    this.actions
      .confirmUpdateFromAdmin('schedule-rule-popup', this.shopId())
      .subscribe(() => this.loadRule())
  }
}
